import { AbstractBrowserFeature } from './AbstractBrowserFeature';
import type { HighEntropyBrowserHints, LowEntropyBrowserHints } from './browserFeatures.types';

/**
 * Defaults for an unknown desktop device.
 *
 * This is what we'd parse from a request with no user agent of hint headers.
 */
const defaultLowEntropyHints: LowEntropyBrowserHints = {
  isMobile: false,
  platform: 'Unknown',
  browsers: [],
  saveData: false,
};

/** Implementation of the browser features that uses values passed in the constructor. */
export class StaticBrowserFeature extends AbstractBrowserFeature {
  protected computeLowEntropyHints(): LowEntropyBrowserHints {
    return this.lowEntropyHints ?? defaultLowEntropyHints;
  }

  protected computeHighEntropyHintsAsync(): Promise<HighEntropyBrowserHints> {
    return Promise.resolve(this.highEntropyHints ?? {});
  }
}
